import { Button, CircularProgress, IconButton } from '@material-ui/core';
import { PencilSimpleIcon, UserIcon } from '@phosphor-icons/react';
import { Layout } from '@orientaction/components';
import { FC } from 'react';
import { ConfirmActionModal, ResourceSections } from '../shared/components';
import ChangeConsultantModal from './components/ChangeConsultantModal';
import { useStyles } from './styles';
import { useEditPrestation } from './useEditPrestation';

const EditPrestation: FC = () => {
  const classes = useStyles();
  const page = useEditPrestation();

  return (
    <Layout isaddBackground={true}>
      <div className={classes.page}>
        <button
          type="button"
          className={classes.backLink}
          onClick={() => page.requestLeave()}>
          ← Retour
        </button>
        {page.loading ? (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <h1 className={classes.title}>{page.prestationName}</h1>

            <div className={classes.consultantRow}>
              {page.consultantPhoto ? (
                <img src={page.consultantPhoto} alt="" className={classes.avatar} />
              ) : (
                <span className={classes.avatar}>
                  <UserIcon size={22} />
                </span>
              )}
              <div className={classes.consultantMeta}>
                <div className={classes.consultantLabel}>
                  Consultant rattaché à cette prestation
                </div>
                <div className={classes.consultantNameRow}>
                  <span className={classes.consultantName}>{page.consultantName || '—'}</span>
                  {!page.lockConsultant && (
                    <IconButton
                      className={classes.pencilBtn}
                      aria-label="Modifier le consultant"
                      onClick={() => page.setEditingConsultant(true)}>
                      <PencilSimpleIcon size={18} />
                    </IconButton>
                  )}
                </div>
              </div>
            </div>

            <div className={classes.resourcesHeader}>
              <h2 className={classes.sectionTitle}>Ressources</h2>
              <Button
                className={classes.primaryBtn}
                disabled={page.submitting || (page.loadingCatalogs && !page.hydrated)}
                onClick={page.handleSubmit}>
                {page.submitting ? 'Enregistrement...' : 'Enregistrer'}
              </Button>
            </div>

            <ResourceSections
              loading={page.loadingCatalogs && !page.hydrated}
              sections={[
                {
                  kind: 'majorTests',
                  catalog: page.majorCatalog,
                  selected: page.majorTests,
                  showStatus: true,
                },
                {
                  kind: 'minorTests',
                  catalog: page.minorCatalog,
                  selected: page.minorTests,
                  showStatus: true,
                },
                {
                  kind: 'games',
                  catalog: page.gameCatalog,
                  selected: page.games,
                },
                {
                  kind: 'books',
                  catalog: page.bookCatalog,
                  selected: page.books,
                },
                {
                  kind: 'ebooks',
                  catalog: page.ebookCatalog,
                  selected: page.ebooks,
                },
              ]}
              onToggle={page.toggleResource}
              onRemove={page.removeResource}
            />

            <div className={classes.footer}>
              <Button
                className={classes.secondaryBtn}
                disabled={page.deleting}
                onClick={page.askDelete}>
                Supprimer la prestation
              </Button>
            </div>
          </>
        )}
      </div>

      <ChangeConsultantModal
        open={page.editingConsultant}
        consultants={page.consultants}
        consultantId={page.consultantId}
        onClose={() => page.setEditingConsultant(false)}
        onConfirm={page.handleConsultantChange}
      />
      <ConfirmActionModal
        open={page.leaveOpen}
        title={page.leaveTitle}
        text={page.leaveText}
        confirmLabel={page.leaveConfirm}
        onClose={page.closeLeave}
        onConfirm={page.confirmLeave}
      />
      <ConfirmActionModal
        open={page.deleteOpen}
        title={page.deleteTitle}
        text={page.deleteText}
        confirmLabel={page.deleteConfirm}
        confirming={page.deleting}
        onClose={page.closeDelete}
        onConfirm={page.confirmDelete}
      />
    </Layout>
  );
};

export default EditPrestation;
